import {
  Container,
  Flex,
  Box,
  Heading,
  Text,
  IconButton,
  Button,
  VStack,
  HStack,
  Wrap,
  WrapItem,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Textarea,
} from "@chakra-ui/react";
import { MdPhone, MdEmail, MdLocationOn, MdMailOutline } from "react-icons/md";
import { BsPerson } from "react-icons/bs";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { SocialButton } from "../footer/social-btn";
import { FiGitlab } from "react-icons/fi";

export const ContactComponent = () => {
  return (
    <Container bg="gray.200" maxW="full" mt={0} centerContent overflow="hidden">
      <Flex>
        <Box
          bg="green.400"
          color="white"
          borderRadius="lg"
          m={{ sm: 4, md: 16, lg: 10 }}
          p={{ sm: 5, md: 5, lg: 16 }}
        >
          <Box p={4}>
            <Wrap spacing={{ base: 20, sm: 3, md: 5, lg: 20 }}>
              <WrapItem>
                <Box>
                  <Heading>Contact-me</Heading>
                  <Box py={{ base: 5, sm: 5, md: 8, lg: 10 }}>
                    <VStack pl={0} spacing={3} alignItems="flex-start">
                      <Button
                        size="md"
                        height="48px"
                        width="200px"
                        variant="ghost"
                        color="#DCE2FF"
                        _hover={{ border: "1px solid #82cfff" }}
                        leftIcon={<MdEmail size="20px" />}
                      >
                        diornister@gmail.com
                      </Button>

                      <Button
                        size="md"
                        height="48px"
                        width="200px"
                        variant="ghost"
                        color="#DCE2FF"
                        _hover={{ border: "1px solid #82cfff" }}
                        leftIcon={<MdPhone size="20px" />}
                      >
                        +55 (31) 97362-0611
                      </Button>

                      <Button
                        size="md"
                        height="48px"
                        width="200px"
                        variant="ghost"
                        color="#DCE2FF"
                        _hover={{ border: "1px solid #82cfff" }}
                        leftIcon={<MdLocationOn size="20px" />}
                      >
                        Belo Horizonte, Brazil
                      </Button>
                    </VStack>
                  </Box>

                  <HStack
                    mt={{ lg: 10, md: 10 }}
                    spacing={5}
                    px={5}
                    alignItems="flex-start"
                  >
                    <SocialButton
                      label={"Linkedin"}
                      href={
                        "https://www.linkedin.com/in/diogenes-morais-244112121/"
                      }
                    >
                      <FaLinkedin />
                    </SocialButton>

                    <SocialButton
                      label={"Gitlab"}
                      href={"https://gitlab.com/diornister"}
                    >
                      <FiGitlab />
                    </SocialButton>

                    <SocialButton
                      label={"Github"}
                      href={"https://github.com/diornister"}
                    >
                      <FaGithub />
                    </SocialButton>
                  </HStack>
                </Box>
              </WrapItem>

              {/* <WrapItem>
                <Box bg="white" borderRadius="lg">
                  <Box m={8} color="#0B0E3F">
                    <VStack spacing={5}>
                      <FormControl id="name">
                        <FormLabel>Your Name</FormLabel>
                        <InputGroup borderColor="#E0E1E7">
                          <InputLeftElement
                            pointerEvents="none"
                            children={<BsPerson color="gray.800" />}
                          />
                          <Input type="text" size="md" />
                        </InputGroup>
                      </FormControl>

                      <FormControl id="name">
                        <FormLabel>Mail</FormLabel>
                        <InputGroup borderColor="#E0E1E7">
                          <InputLeftElement
                            pointerEvents="none"
                            children={<MdMailOutline color="gray.800" />}
                          />
                          <Input type="text" size="md" />
                        </InputGroup>
                      </FormControl>

                      <FormControl id="name">
                        <FormLabel>Message</FormLabel>
                        <Textarea
                          borderColor="gray.300"
                          _hover={{
                            borderRadius: "gray.300",
                          }}
                          placeholder="message"
                        />
                      </FormControl>
                      <FormControl id="name" float="right">
                        <Button
                          variant="solid"
                          bg="#0D74FF"
                          color="white"
                          _hover={{}}
                        >
                          Send Message
                        </Button>
                      </FormControl>
                    </VStack>
                  </Box>
                </Box>
              </WrapItem> */}
            </Wrap>
          </Box>
        </Box>
      </Flex>
    </Container>
  );
};
